/* eslint-disable react/no-unknown-property */
import React from 'react';

import { Grid, Typography } from '@mui/material';
import { Wormhole } from 'src/v2/components/ui/images';

import { primaryColors } from '~components/theme/styles/colors';

import SlideWrapper from '../SlideWrapper';

function RoadmapLandingSlide() {
  return (
    <SlideWrapper
      sx={{
        justifyContent: 'center',
        overflow: 'hidden',
        pt: 32,
      }}
    >
      <Grid
        container
        direction={{ xs: 'column-reverse', sm: 'row' }}
        justifyContent={'start'}
        textAlign={'left'}
        spacing={1}
      >
        <Grid item xs={12} sm={7} pr={2}>
          <Typography variant={'h2'} mt={4}>
            Roadmap
          </Typography>
          <Typography variant={'body1'} mt={4} mb={8} color={primaryColors[400]}>
            At Vesta, we strive for transparency by clearly displaying all fees within the application and
            providing detailed explanations in our documentation.
          </Typography>
        </Grid>
        <Grid item textAlign={'center'} xs={12} sm={5}>
          <Wormhole />
        </Grid>
      </Grid>
    </SlideWrapper>
  );
}

export default RoadmapLandingSlide;
